import { Component, HostListener, OnInit } from '@angular/core';

@Component({
  selector: 'app-creteria-one',
  templateUrl: './creteria-one.component.html',
  styleUrls: ['./creteria-one.component.scss']
})
export class CreteriaOneComponent implements OnInit {
  @HostListener("click") onClick(){
    this.checkRoute();
  }
  fullWidth=false;
  showSideMenu = true;
  showHeading = false;
  constructor() { }

  ngOnInit(): void {
    this.checkRoute();
  }

  splitUrl(){
    let url=location.pathname.split('/');
    // console.log(url);
    if(url.length === 4 ){
      this.showSideMenu=true;
      this.fullWidth=false;
      this.showHeading = true;
    }
    else if(url.length === 5){
      this.showSideMenu=false;
      this.fullWidth=true;
      this.showHeading = false;
    }
    else{
      this.showSideMenu=false;
      this.fullWidth=true;
    }
  }
  checkRoute(){
    setTimeout(()=>{
      this.splitUrl();
    })
  }
}
